import { InputSkeleton, TextareaSkeleton } from '@/_components';
import {
  CardContainer,
  Container,
  ContainerLayout,
  FormLayout,
  LeftSection,
  RightSection,
  SectionHeadingSkeleton,
  StickyPageHeaderSkeletonWithButtons,
} from '@/_containers';
import AddressFormLoading from '@/_containers/inputs/address/loading';
import PhoneNumberLoading from '@/_containers/inputs/phone-number/loading';

export default function Loading() {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={2} withBreadcrumb />

      <Container>
        <LeftSection>
          <CardContainer>
            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
              <TextareaSkeleton className="col-span-12" />
            </FormLayout>
          </CardContainer>

          <CardContainer>
            <SectionHeadingSkeleton />

            <AddressFormLoading />
          </CardContainer>
          <CardContainer>
            <SectionHeadingSkeleton />

            <AddressFormLoading />
          </CardContainer>
        </LeftSection>
        <RightSection>
          <CardContainer right>
            <SectionHeadingSkeleton withRightSlot />
            <PhoneNumberLoading />
          </CardContainer>
        </RightSection>
      </Container>
    </ContainerLayout>
  );
}
